import one from '@mailobj-browser/front/js/selectors/one.js'
import { rtes } from './iframe.js'

export const iframeOnInput = (contentDocument) => {
  const { body } = contentDocument
  const { scrollHeight } = body
  const rte = rtes.get(contentDocument)

  requestAnimationFrame(() => {
    if (rte) {
      const iframe = one('iframe', rte)
      const { style } = iframe

      if (style) {
        style.setProperty('--ea_rte_iframe_height', `${scrollHeight}px`)
      }
    }
  })
}